import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { COPY_EVENT_QUERY } from '../../../graphql.js'
import { useNavigate } from 'react-router'
import { handleGraphQLErrors } from '../../../utils.js'

export const COPY_EVENT = gql(COPY_EVENT_QUERY)

export default function CopyLink({ location }) {
  console.log('CopyLink rendered')

  const [graphQLErrors, setGraphQLErrors] = useState([])
  const navigate = useNavigate()
  useEffect(() => {
    async function copyEvent() {
      try {
        const params = new URLSearchParams(location.search)
        const eventId = params.get('eventId')
        const sourceString = params.get('source')
        const { data, errors } = await window.apolloClient.query({ query: COPY_EVENT, variables: { eventId: eventId} })
        if (data.copyEvent) {
          navigate(`/object/${data.copyEvent.newEventId}?actionId=${data.copyEvent.modifyActionId}&source=${sourceString}`, { replace: true})
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    copyEvent()
  }, [location.search, navigate])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else {
    return <Spinner />
  }
}
